import { ActionButton } from '@knocklabs/client';
import { RibbonToastPrimaryAction } from '@mi-front/ui';
import { Box } from '@mui/material';
import { opensNotificationActionInNewTab } from '../../shared/notification-action-url';

export type NotificationFeedItemActionsProps = {
  buttons: ActionButton[];
  onButtonClick: (button: ActionButton) => void;
};

/**
 * Renders Knock template action buttons under a feed item as compact chips
 * (same control as ribbon toast primary actions).
 */
export function NotificationFeedItemActions({
  buttons,
  onButtonClick,
}: NotificationFeedItemActionsProps) {
  if (buttons.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 1 }}>
      {buttons.map((button) => {
        const opensInNewTab = Boolean(
          button.action && opensNotificationActionInNewTab(button.action),
        );

        return (
          <RibbonToastPrimaryAction
            key={button.name}
            label={button.label}
            opensInNewTab={opensInNewTab}
            onAction={() => onButtonClick(button)}
          />
        );
      })}
    </Box>
  );
}
